<div class="gpd-config-section">
  <div class="gpd-config-section-header">
    <div>
      <div class="gpd-config-section-title">
        <span i18n="@@remunerationTypes">Remuneration Types</span>
      </div>
      <div class="gpd-config-section-description" i18n="@@remunerationTypesConfigDescription">Define remuneration Types</div>
    </div>
    <app-gpd-button i18n-text="@@add" text="Add" icon="add" (onClick)="onAdd()" [disabled]="editData"></app-gpd-button>
  </div>
  <div class="section-form" *ngIf="editData">
    <dx-form #form class="gpd-form" [colCount]="2">
      <dxi-item [colSpan]="1" dataField="title">
        <dxo-label i18n-text="@@title" text="Title"></dxo-label>
        <dx-text-box class="gpd-input" [(value)]="editData.title" valueChangeEvent="input">
          <dx-validator >
            <dxi-validation-rule type="required" i18n-message="@@required" message="Required"></dxi-validation-rule>
            <dxi-validation-rule type="custom" [reevaluate]="true" [validationCallback]="validateUniqueTitle" i18n-message="@@titleAlreadyExists" message="Title already exists"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </dxi-item>
      <dxi-item [colSpan]="2" dataField="buttons">
        <dxo-label [visible]="false"></dxo-label>
        <div class="section-form-buttons gpd-button-group">
          <app-gpd-button i18n-text="@@cancel" text="Cancel" icon="cancel" (onClick)="onCancel()" type="secondary"></app-gpd-button>
          <app-gpd-button i18n-text="@@save" text="Save" icon="tick" (onClick)="$event.validationGroup.validate().isValid  && onSave($event)" type="primary"></app-gpd-button>
        </div>
      </dxi-item>
    </dx-form>
  </div>
  <div class="gpd-config-section-content" *ngIf="remunerationTags.length > 0 && !editData">
    <dx-data-grid
      #dgrid
      [dataSource]="remunerationTags || []"
      class="gpd-datagrid"
      width="100%"
      [showBorders]="true"
      [allowColumnResizing]="true"
      [columnAutoWidth]="true"
      [columnHidingEnabled]="true"
      [allowColumnReordering]="true"
    >
      <dxi-column dataField="title" i18n-caption="@@title" caption="Title"></dxi-column>
      <dxi-column
        dataField=""
        allowEditing="false"
        cellTemplate="buttonCellTemplate"
        [width]="100"
        [formItem]="{ visible: false }"
      >
        <div *dxTemplate="let item of 'buttonCellTemplate'">
          <div class="gpd-table-actions">
            <app-svg-icon
              icon="edit"
              color="var(--color-primary)"
              [strokeWidth]="1.5"
              [size]="20"
              class="gpd-button-icon"
              (click)="onEdit(item.data)"
            ></app-svg-icon>
            <app-svg-icon
              icon="delete"
              color="var(--color-red-500)"
              [strokeWidth]="1.5"
              [size]="20"
              class="gpd-button-icon"
              (click)="deleteRemunerationTag(item.data)"
            ></app-svg-icon>
          </div>
        </div>
      </dxi-column>
    </dx-data-grid>
  </div>
</div>
